
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-atlas",
      function () {
        return require("private-next-pages/ai-atlas.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-atlas"])
      });
    }
  